module.exports = __webpack_public_path__ + "img/home_track.53fe3408.png";